import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BasicRequest } from "../Common/SubSections/BasicRequest";
import { IFile } from "../../../types/IFile";
import { IRequestNew, IRequestType } from "../../../types/IRequest";
import { saveGeneralRequest } from "../../../repos/GeneralRepo";
import { FilesUpload } from "../Common/SubSections/FilesUpload";
import { CustomRequestSection } from "../CustomRequestSection";
import { deleteProps } from "@inceptionbg/ui-components";

interface Props {
  requestType?: IRequestType;
}

export const ComplaintSection: FC<Props> = ({ requestType }) => {
  const [requestData, setRequestData] = useState<IRequestNew>({});
  const [storedFiles, setStoredFiles] = useState<IFile[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    if (requestType) {
      setRequestData((prev) => ({ ...prev, requestType }));
    }
  }, [requestType]);

  const onSubmit = () => {
    setIsLoading(true);
    saveGeneralRequest(
      deleteProps(
        {
          ...requestData,
          caseId: requestData.case?.caseId,
          storedFiles,
          deliveryType: "INBOX",
        },
        ["case"]
      )
    )
      .then(() => {
        setRequestData(requestType ? { requestType } : {});
        setStoredFiles([]);
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  };

  return (
    <CustomRequestSection
      sectionTitle={t(`PageTitle${requestType}`)}
      infoBoxTitle={t(`ComplaintRequestTitle${requestType}`)}
      infoBoxDesc={t(`ComplaintRequestDesc${requestType}`)}
      onSubmit={onSubmit}
      buttonLabel={t(`ConfirmLabel${requestType}`)}
      disableSubmit={
        !requestData.case || !requestData.requestType || !requestData.note
      }
    >
      <BasicRequest
        mode="COMPLAINT"
        data={requestData}
        setData={setRequestData}
        isLoading={isLoading}
      />
      <FilesUpload
        storedFiles={storedFiles}
        setStoredFiles={setStoredFiles}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
    </CustomRequestSection>
  );
};
